import { defineCollection } from "@rebasepro/cms-types";
import type { CollectionConfig } from "@rebasepro/types";
import challengesCollection from "./challenges";
import { personName, playerOf } from "../people";

// A challenge started (songbuzz_solo_duel_attempt): its ticket, like a Daily Gig's, so the score is timed and checked.
// backend/functions/songbuzz.ts creates and writes it.
const challengeAttemptsCollection = defineCollection({
    name: "Challenge attempts",
    singularName: "Challenge attempt",
    slug: "challenge_attempts",
    table: "songbuzz_solo_duel_attempt",
    description: "Every challenge someone started, and who.",
    securityRules: [{ operation: "select", roles: ["admin"] }],
    properties: {
        duel: { name: "Challenge code", type: "string", isId: "manual", admin: { readOnly: true, hideFromCollection: true } },
        // the account ("u:<uid>") or, for Solo without one, the device
        sid: { name: "Player id", type: "string", isId: "manual", admin: { readOnly: true, hideFromCollection: true } },
        player: playerOf("Player", "sid", "player"),
        challenge: {
            name: "Challenge", type: "relation",
            relation: { kind: "via", cardinality: "one", target: (): CollectionConfig => challengesCollection, relationName: "challenge", joinPath: [{ table: "songbuzz_solo_duel", on: { from: "duel", to: "id" } }] },
            admin: { readOnly: true },
        },
        token: { name: "Ticket", type: "string", validation: { required: true }, admin: { readOnly: true, hideFromCollection: true } },
        startedAt: { name: "Started", type: "date", autoValue: "on_create", validation: { required: true }, admin: { readOnly: true } },
    },
    admin: {
        icon: "Ticket",
        group: "System",
        openEntityMode: "side_panel",
        sort: ["startedAt", "desc"],
        display: {
            title: async ({ entity, context }) => personName(context, entity.values.sid),
            subtitle: () => "Started a challenge",
            date: "startedAt",
        },
        form: {
            sections: [
                { key: "attempt", properties: ["player", "challenge", "startedAt"] },
                { key: "ids", title: "Behind the scenes", collapsed: true, properties: ["duel", "sid", "token"] },
            ],
        },
    },
});

export default challengeAttemptsCollection;
